
import ActionSheet from 'vant/lib/action-sheet';
import { defineComponent, onMounted, getCurrentInstance } from 'vue';
import { logForFantasyPopupShow } from '../../scripts/logger';

const InstallPopupClose = 'https://cdn-static.ap4r.com/kos/s101/nlav11312/kos/s101/nlav11312/pwa/mobile/aichat/close.png';
const PtBRPopupImage = 'https://cdn-static.ap4r.com/kos/s101/nlav11312/kos/s101/nlav11312/pwa/mobile/aichat/popup_img_pt-BR.png';
const DefaultPopupImage = 'https://cdn-static.ap4r.com/kos/s101/nlav11312/kos/s101/nlav11312/pwa/mobile/aichat/popup_img_en_v2.png';

export default defineComponent({
    components: {
        vanActionSheet: ActionSheet,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        botID: {
            type: String,
            default: '',
        },
    },
    emits: ['confirm', 'cancel'],
    setup(props, { emit }) {
        const { proxy }: any = getCurrentInstance() || {};
        const lang = proxy?.$root?.$i18n?.locale || 'en';
        const popupImage = lang.includes('pt') ? PtBRPopupImage : DefaultPopupImage;

        const handleConfirm = () => {
            emit('confirm', props.botID);
        };

        const handleCancle = () => {
            emit('cancel');
        };

        onMounted(() => {
            // 埋点上报
            logForFantasyPopupShow('dialogue');
        });
        return {
            InstallPopupClose,
            popupImage,

            handleCancle,
            handleConfirm,
        };
    },
});
